<template>
  <pack>
    <el-form label-width="170px" label-position="left">
      <el-form-item label="业务域名">
        <template v-for="(item,idx) in webviewdomain">
          <div :key="idx + 'webviewdomain'">
            <el-input v-model="webviewdomain[idx]"></el-input>
            <i class="el-icon-circle-plus-outline" @click="add(webviewdomain)" v-if="idx==0"></i>
            <i class="el-icon-remove-outline warn" @click="del(webviewdomain,idx)" v-else></i>
          </div>
        </template>
      </el-form-item>
    </el-form>
    <zt-button type="primary">保存</zt-button>
  </pack>
</template>

<script>
import { admin_plugin_wxapp_api } from '@/api/program';
export default {
  name: 'service',
  props: {
    editList: Array,
  },
  data: () => ({
    webviewdomain: [],
  }),
  mounted() {
    this.getList();
  },
  methods: {
    add(list) {
      list.push('');
    },
    del(list, idx) {
      list.splice(idx, 1);
    },
    getList() {
      let params = {
        id: this.editList[0].id,
        url:
          'https://api.weixin.qq.com/wxa/setwebviewdomain?access_token=ACCESS_TOKEN',
        data: JSON.stringify({
          action: 'get',
        }),
      };
      admin_plugin_wxapp_api(params).then(({ data }) => {
        if (data.error_code == 0) {
          if (data.result.errcode) return;
          const { result } = data;
          this.webviewdomain = result.webviewdomain;
          // 如果一个域名都没有填充一个空字符串
          ['webviewdomain'].map((arr) => {
            if (this[arr].length == 0) {
              this[arr].push('');
            }
          });
        } else {
          this.$message.error(data.error_message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
i {
  cursor: pointer;
  font-size: 30px;
  color: $theme;
  vertical-align: middle;
  margin-left: 10px;
}
.warn {
  color: #fd5252;
}
/deep/ .el-input {
  width: 400px;
}
/deep/ .el-button {
  width: 120px;
  margin-top: 20px;
}
</style>